import React from 'react';
import { TbCancel } from "react-icons/tb";
import { FaArrowRight, FaArrowLeft, FaSave } from "react-icons/fa";
import { Tooltip } from '../Tooltip';

interface AntragButtonsProps {
    onBack: () => void;
    onNext: () => void;
    onSave: () => void;
    isNextDisabled: boolean;
    loading: boolean;
    isViewOnly?: boolean;
    isFirstPage?: boolean;
}

const AntragButtons: React.FC<AntragButtonsProps> = ({ onBack, onNext, onSave, isNextDisabled, loading, isViewOnly, isFirstPage }) => {
    return (
        <div className='antrag-buttons'>
            {!isFirstPage ? (
                <button
                    type='button'
                    className='antrag-switch-page'
                    onClick={onBack}
                >
                    <FaArrowLeft className='antrag-switch-page-icon' /> Zurück
                </button>
            ) : (
                <button
                    type='button'
                    className='antrag-switch-page'
                    onClick={onBack}
                >
                    <TbCancel className='antrag-switch-page-icon' /> Abbrechen
                </button>
            )}
            <button
                type='button'
                className='antrag-switch-page'
                onClick={onNext}
                disabled={isNextDisabled}
            >
                Weiter <FaArrowRight className='antrag-switch-page-icon' />
            </button>
            {!isViewOnly && (
                <Tooltip text="Speichern Sie Ihre Daten">
                    <button
                        type='button'
                        className='save-button'
                        onClick={onSave}
                        disabled={loading}
                    >
                        <FaSave className='antrag-switch-page-icon' /> Speichern
                    </button>
                </Tooltip>
            )}
        </div>
    );
};

export default AntragButtons;